export const replace = <T extends object | Array<any>>(arr: T, to: T) => {
  if (Array.isArray(arr)) {
    arr.length = 0
    arr.push(...to as Array<any>)
  } else {
    for (let key of Object.keys(arr)) {
      delete arr[key as keyof T]
    }
    Object.assign(arr, to)
  }
}